import {
	type CustomerUpdateDto,
	patchCustomersId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useUpdateCustomer = (customerId: number, orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: CustomerUpdateDto) =>
			patchCustomersId(data, customerId),
		),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.customerUpdateError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(orderMutationsResource.customerUpdateSuccess));
			queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) });
		},
	});
};
